import { render, staticRenderFns } from "./CertificationPopup.vue?vue&type=template&id=3632413e&scoped=true&"
import script from "./CertificationPopup.vue?vue&type=script&lang=ts&"
export * from "./CertificationPopup.vue?vue&type=script&lang=ts&"
import style0 from "./CertificationPopup.vue?vue&type=style&index=0&id=3632413e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3632413e",
  null
  
)

export default component.exports